(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spacer-pdp-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spacer-pdp-product')) {
  customElements.define('spacer-pdp-product', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelector('[data-variant-input]').disabled = false;
      this.initialSelection = [...this.querySelectorAll('[data-option-value-id]:checked')].map(input => input.dataset.optionValueId);
      this.initialDisabled = this.querySelector('[name=add]').disabled;
      this.addEventListener('submit', event => {
        if (this.getAttribute('aria-busy') === 'true' || this.querySelector('[name=add]').disabled) event.preventDefault();
      }, options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-value-id]')) this.changeVariant(event.target);
      }, options);
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-media-target]');
        if (thumbnail) this.showMedia(thumbnail.dataset.mediaTarget);
        const play = event.target.closest('.sp-pdp-external-play');
        if (play) {
          const template = play.parentElement.querySelector('[data-external-media]');
          if (template) { play.hidden = true; play.parentElement.appendChild(template.content.cloneNode(true)); }
        }
      }, options);
    }
    showMedia(id) {
      this.querySelectorAll('[data-media-id]').forEach(panel => {
        const selected = panel.dataset.mediaId === id;
        panel.hidden = !selected;
        if (!selected) {
          panel.querySelectorAll('video').forEach(video => video.pause());
          panel.querySelectorAll('iframe').forEach(frame => frame.remove());
          const play = panel.querySelector('.sp-pdp-external-play');
          if (play) play.hidden = false;
        }
      });
      this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
    }
    async changeVariant(input) {
      this.pending?.abort();
      const request = new AbortController();
      this.pending = request;
      const selected = [...this.querySelectorAll('[data-option-value-id]:checked')].map(option => option.dataset.optionValueId);
      const url = new URL(input.dataset.productUrl || this.dataset.productUrl, window.location.origin);
      const current = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('option_values', selected.join(','));
      url.searchParams.delete('variant');
      if (url.pathname !== current.pathname) { window.location.assign(url.href); return; }
      const quantity = this.querySelector('[name=quantity]')?.value || '1';
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[name=add]').disabled = true;
      const error = this.querySelector('[data-option-error]');
      error.hidden = true;
      try {
        const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Product option request failed');
        const html = await response.text();
        if (request.signal.aborted) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const replacement = documentFragment.querySelector('[data-sp-product-root]');
        if (!replacement) throw new Error('Product section missing');
        const nextQuantity = replacement.querySelector('[name=quantity]');
        if (nextQuantity) {
          const min = Number(nextQuantity.min || nextQuantity.value || 1);
          const max = nextQuantity.max ? Number(nextQuantity.max) : Infinity;
          const step = Number(nextQuantity.step || 1);
          let amount = Number(quantity);
          if (!Number.isFinite(amount)) amount = min;
          amount = min + Math.floor((Math.max(min, amount) - min) / step) * step;
          if (amount > max) amount = min + Math.floor((max - min) / step) * step;
          nextQuantity.value = String(Math.max(min, amount));
        }
        const historyUrl = new URL(window.location.href);
        historyUrl.searchParams.delete('section_id');
        if (replacement.dataset.variantId) {
          historyUrl.searchParams.set('variant', replacement.dataset.variantId);
          historyUrl.searchParams.delete('option_values');
        } else {
          historyUrl.searchParams.delete('variant');
          historyUrl.searchParams.set('option_values', selected.join(','));
        }
        window.history.replaceState({}, '', historyUrl);
        const focusedValue = input.dataset.optionValueId;
        this.replaceWith(replacement);
        const nextFocus = [...replacement.querySelectorAll('[data-option-value-id]')].find(option => option.dataset.optionValueId === focusedValue);
        nextFocus?.focus({ preventScroll: true });
        window.Shopify?.PaymentButton?.init?.();
      } catch (failure) {
        if (request.signal.aborted || !this.isConnected) return;
        this.querySelectorAll('[data-option-value-id]').forEach(option => { option.checked = this.initialSelection.includes(option.dataset.optionValueId); });
        error.textContent = this.dataset.errorMessage;
        error.hidden = false;
        this.querySelector('[name=add]').disabled = this.initialDisabled;
      } finally {
        if (this.isConnected && this.pending === request) this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.pending?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
if (!customElements.get('spacer-pdp-tabs')) {
  customElements.define('spacer-pdp-tabs', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      this.panels = [...this.querySelectorAll('[role=tabpanel]')];
      this.setAttribute('data-enhanced', '');
      this.select(0);
      this.media = window.matchMedia('(max-width: 749px)');
      const orient = () => this.querySelector('[role=tablist]')?.setAttribute('aria-orientation', this.media.matches ? 'horizontal' : 'vertical');
      orient();
      this.media.addEventListener('change', orient, options);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role=tab]');
        if (tab && this.contains(tab)) this.select(this.tabs.indexOf(tab));
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role=tabpanel]');
        if (panel && this.contains(panel)) this.select(this.panels.indexOf(panel));
      }, options);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spacer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spacer-hero-video')) {
  customElements.define('spacer-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.button.hidden = false;
      this.userPaused = this.motion.matches;
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.video.paused) this.play();
        else this.video.pause();
      }, options);
      this.video.addEventListener('play', () => this.update(), options);
      this.video.addEventListener('playing', () => this.setAttribute('data-started', ''), options);
      this.video.addEventListener('pause', () => this.update(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.userPaused = true; this.video.pause(); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !this.userPaused && !document.hidden) this.play();
        else this.video.pause();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else if (this.visible && !this.userPaused) this.play();
      }, options);
      this.update();
    }
    play() { this.video.play().catch(() => this.update()); }
    update() {
      this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.play : this.button.dataset.pause);
      this.button.querySelector('[data-icon]').textContent = this.video.paused ? '▶' : 'Ⅱ';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}
if (!customElements.get('spacer-video-card')) {
  customElements.define('spacer-video-card', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const trigger = this.querySelector('button');
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        const template = this.querySelector('template');
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        if (!video) return;
        document.querySelectorAll('spacer-video-card > video').forEach(other => other.pause());
        video.setAttribute('aria-label', trigger.getAttribute('aria-label'));
        video.tabIndex = 0;
        trigger.remove();
        template.remove();
        this.appendChild(fragment);
        video.focus();
        video.play().catch(() => {});
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelector('video')?.pause();
    }
  });
}
if (!customElements.get('spacer-carousel')) {
  customElements.define('spacer-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('[data-track]');
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (!track || !previous || !next) return;
      const move = direction => track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      const update = () => {
        const left = Math.abs(track.scrollLeft);
        previous.disabled = left <= 2;
        next.disabled = left + track.clientWidth >= track.scrollWidth - 2;
      };
      track.addEventListener('scroll', update, options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.sp-athlete');
        if (card && this.contains(card)) track.scrollTo({ left: card.offsetLeft - track.offsetLeft - 20, behavior: 'auto' });
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
